import dayjs from 'dayjs'
import type { PERIOD_TYPE } from '../../../lib/apis/dtos/request/quotation.request'
import { forwardRef } from 'react'
import { cn } from '../../../utils/cn.utils'

export const SPAN_STYLE =
  'text-[11px] pl-[2px] text-[#C9C5C6] shrink-0 text-[11px]'

interface PriceInputProps {
  value: number | string | undefined | null
  onChange: (value: number | string) => void
  maxLength?: number
  suffix?: string
  allowDecimal?: boolean // if true, allows 1 decimal place
  disabled?: boolean
  regex?: RegExp
  placeholder?: string
  periodType?: PERIOD_TYPE
  errorField?: string
}

export const PriceInput = forwardRef(
  (
    {
      value,
      onChange,
      maxLength = 7,
      periodType,
      suffix = '원',
      regex,
      allowDecimal = false,
      placeholder = '',
      disabled = false,
      errorField,
    }: PriceInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    // 잔여일 텍스트를 변수로 분리 (가독성)
    const remainingDays = dayjs().endOf('month').diff(dayjs(), 'day') + 1

    return (
      <div
        className="flex w-full min-w-0 items-center justify-end overflow-hidden"
        style={{ maxWidth: '100%' }}
      >
        {periodType === 'M_PLUS_N' && (
          <div className="mr-1 min-w-0 shrink flex-row gap-2 text-[10px] font-medium whitespace-nowrap text-[#79747E]">
            <span className="">이번달 잔여일 {remainingDays}일</span>
            <span>+</span>
          </div>
        )}

        <input
          data-error-field={errorField}
          className="min-w-0 flex-1 border-none bg-transparent text-right text-[11px] font-medium outline-none"
          style={{ width: '0', minWidth: '0' }}
          ref={ref}
          value={value?.toLocaleString('ko-KR') || ''}
          maxLength={maxLength}
          disabled={disabled}
          placeholder={placeholder}
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            if (disabled) return
            const input = e.currentTarget
            const length = input.value.length
            input.setSelectionRange(length, length)
          }}
          onChange={(e) => {
            let val = e.target.value.replace(/,/g, '')
            const _regex = regex
              ? regex
              : allowDecimal
                ? /^-?\d*\.?\d{0,1}$/  // {0,1}로 수정
                : /^-?\d*$/

            if (_regex.test(val)) {
              // 소수점을 허용할 때는 사용자가 '.'을 입력하는 중간 단계를 위해 문자열로 넘기는 것이 정석입니다.
              // 정수만 허용할 때는 Number(val)로 변환하되, 빈 값과 '-' 부호 예외 처리를 유지합니다.
              const finalValue = allowDecimal
                ? val
                : val === '' || val === '-'
                  ? val
                  : Number(val)

              onChange(finalValue)
            }
          }}
        />

        {suffix && (
          <span className={cn(SPAN_STYLE)}>
            {!!periodType ? (periodType === 'DAY' ? '일' : '개월') : suffix}
          </span>
        )}
      </div>
    )
  },
)
